import { render, staticRenderFns } from "./DetailPKBPage.vue?vue&type=template&id=d9899aac&scoped=true&"
import script from "./DetailPKBPage.vue?vue&type=script&lang=js&"
export * from "./DetailPKBPage.vue?vue&type=script&lang=js&"
import style0 from "./DetailPKBPage.vue?vue&type=style&index=0&id=d9899aac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9899aac",
  null
  
)

export default component.exports